var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
});

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  console.log(wishlist);
  if (wishlist.length === 0) {
  //	return "fffffffff";
    
     grid.innerHTML =  "<div class='my_whishlist'><h2> <i class='fa fa-heart-o'></i> MY FAVORITE</h2><p>  This is where we store all the styles you added to wishlist! </p></div>";
  }else{
     grid.innerHTML =  "<div class='my_whishlist_data'><h2> <i class='fa fa-heart-o'></i>MY FAVORITE</h2></div>";
    var requests = wishlist.map(function (handle) {
      var productTileTemplateUrl = '/products/' + handle + '?view=card';
      return fetch(productTileTemplateUrl).then(function (res) {
        return res.text();
      });
    });
    Promise.all(requests).then(function (responses) {
      var wishlistProductCards = responses.join('');
      grid.innerHTML += wishlistProductCards;
      var buttons = grid.querySelectorAll(selectors.button) || [];
      if (buttons.length) setupButtons(buttons);
    });
  }
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', function () {
     // alert("");
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) {
    //alert(wishlist);
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  }
  else{
    //alert("aa");
   // alert(wishlist);
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }
  return wishlist;
};

var updateWishlist = function (handle) {
 
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1){
     //alert("ss");
    wishlist.push(handle);
     jQuery.getJSON('/products/'+handle+'.js', function(product) {
       console.log(product);
       jQuery(".swym-redirect").attr("href",product.url);
       jQuery(".swym-title .swym-redirect").html(product.title);
       jQuery(".swym-price").html(Shopify.formatMoney(product.price, "${{amount}}"));
       
       jQuery(".swym-vertical-middler-cell  img").attr("src",product.featured_image);
       jQuery("#swym-notification").addClass('open_data');
       
       
       //jQuery(".swym-vertical-middler-cell  img").attr("src",imgURL(product.featured_image, 'medium'));
      //alert('The title of this product is ' + product.title);
    } );
  }
  else{
     //alert("bb");
    wishlist.splice(indexInWishlist, 1);
  }
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

jQuery("a#swym-close-notification-button").click(function(){
  jQuery("#swym-notification").removeClass('open_data');
  return false;
});